import {
  SALESFORCE_DATA_SOURCE_TYPE,
  SNOWFLAKE_DATA_SOURCE_TYPE,
} from '@/constants/data_sources';

/**
 * The Partner Mapping tab is exposed for any Salesforce or Snowflake data
 * source. These are the source types whose partner mappings have a consumer
 * today — the SFDC overlap push, the Snowflake share, and recommended partners
 * — so the tab is gated on the source type rather than on a specific live push.
 * Extend this list when another source type starts consuming the mappings.
 */
export function isPartnerMappingEligibleFeedType(
  feedType: string | undefined,
): boolean {
  return (
    feedType === SALESFORCE_DATA_SOURCE_TYPE ||
    feedType === SNOWFLAKE_DATA_SOURCE_TYPE
  );
}
